import RadioGroup from '../../components/RadioGroup/RadioGroup'
import useRouter from '../../hooks/useRouter'
import { useEffect, useMemo, useState } from 'react'
import { safeString } from '../../helper/common'
import { routes } from '../../router'
import { useNavigate } from 'react-router'
import { CONTRACTS_PAGE_OPTIONS } from './routesConstants'
import { ContractsTable } from './ContactsTable'
import { useContractPageContext } from '../../pages/Contracts/Providers/ContractPageContextProvider'
import { CategoriesContainer } from '../Categories/CategoriesContainer'

const ContractsPage = () => {
  const navigate = useNavigate()
  const { query, push, location } = useRouter()
  const { state } = useContractPageContext()
  const { isCanSeeCategories, isCanSeeShortCategoriesOnly } = state
  const [activeSubTab, setActiveSubTab] = useState(
    query?.subtab || CONTRACTS_PAGE_OPTIONS[0].value
  )
  const handleTabs = (e) => {
    setActiveSubTab(e)
    if (isCanSeeCategories) {
      push(e)
    } else {
      navigate(routes.contracts + '/' + e)
    }
  }
  useEffect(() => {
    if (location?.pathname?.includes(CONTRACTS_PAGE_OPTIONS[1].value)) {
      setActiveSubTab(CONTRACTS_PAGE_OPTIONS[1].value)
    } else if (location?.pathname?.includes(CONTRACTS_PAGE_OPTIONS[2].value)) {
      setActiveSubTab(CONTRACTS_PAGE_OPTIONS[2].value)
    } else {
      setActiveSubTab(CONTRACTS_PAGE_OPTIONS[0].value)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query?.type])
  useEffect(() => {
    if (query?.subtab) {
      setActiveSubTab(safeString(query?.subtab))
      navigate(routes.contracts + routes.centralRepository, {
        replace: true
      })
    }
  }, [navigate, query?.subtab])

  const optionsForContracts = useMemo(() => {
    return isCanSeeCategories
      ? CONTRACTS_PAGE_OPTIONS
      : CONTRACTS_PAGE_OPTIONS.filter((i) => i.value !== 'contract_categories')
  }, [isCanSeeCategories])
  return (
    <div className="contracts-page-wrapper">
      <div className="mb-24">
        <RadioGroup.Buttons
          options={optionsForContracts}
          defaultValue={activeSubTab}
          onChange={handleTabs}
        />
      </div>
      {!activeSubTab && <ContractsTable />}
      {activeSubTab === CONTRACTS_PAGE_OPTIONS[0].value && <ContractsTable />}
      {activeSubTab === CONTRACTS_PAGE_OPTIONS[1].value &&
        isCanSeeCategories && (
          <CategoriesContainer shortView={isCanSeeShortCategoriesOnly} />
        )}
      {activeSubTab === CONTRACTS_PAGE_OPTIONS[2].value && <ContractsTable />}
    </div>
  )
}

export default ContractsPage
